import { adminHttpClient } from '../commons/adminHttpClient'

export type TotalSpentByCategory = {
  category: {
    id: number
    name: string
  }
  amount: number
}

const getTotalSpentByCategory = (planPeriodId: string, date?: string): Promise<TotalSpentByCategory[]> => {
  return adminHttpClient.get(`Expenses/Reports/SpendingByExpenseCategory/${planPeriodId}?date=${date ?? ''}`)
}

export default getTotalSpentByCategory
